import { atom, useAtom } from 'jotai';
import { useParams } from 'react-router-dom';
import { jotaiStore } from 'stores/jotai.store';

type IsBackgroundSubmittingType = {
  isBackgroundSubmitting: boolean;
  proposalId?: number;
};

export const isBackgroundSubmittingAtom = atom<IsBackgroundSubmittingType>({
  isBackgroundSubmitting: false
});

export const setIsBackgroundSubmitting = (value: IsBackgroundSubmittingType) => {
  jotaiStore.set(isBackgroundSubmittingAtom, value);
};

export const useIsBackgroundSubmitting = () => {
  const { id } = useParams<{ id?: string }>();
  const proposalIdFromQuery = id ? Number(id) : undefined;
  const [{ isBackgroundSubmitting: isGlobalFetching, proposalId }] = useAtom(
    isBackgroundSubmittingAtom
  );
  if (proposalIdFromQuery && proposalIdFromQuery === proposalId && isGlobalFetching === true)
    return true;
  return false;
};
